import { useEffect, useRef, useState } from 'react';
import ButtonLoadingContent from './ButtonLoadingContent';

// Botón que muestra spinner mientras la promesa devuelta por onClick no se resuelve
const AsyncButton = ({
  onClick,
  disabled = false,
  loading = false,
  light = false,
  spinnerSize = '4',
  className = '',
  children,
  type = 'button',
  ...rest
}) => {
  const [pending, setPending] = useState(false);
  const mounted = useRef(true);

  useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; };
  }, []);

  const busy = pending || loading;

  const handleClick = async (event) => {
    if (busy || !onClick) return;
    const result = onClick(event);
    if (!result || typeof result.then !== 'function') return;
    setPending(true);
    try {
      await result;
    } finally {
      if (mounted.current) setPending(false);
    }
  };

  return (
    <button
      type={type}
      {...rest}
      onClick={handleClick}
      disabled={disabled || busy}
      aria-busy={busy}
      className={`${className}${busy ? ' pointer-events-none' : ''}`}
    >
      <ButtonLoadingContent loading={busy} size={spinnerSize} light={light}>
        {children}
      </ButtonLoadingContent>
    </button>
  );
};

export default AsyncButton;
